import {MODAL_SHOW, MODAL_HIDE, MODAL_NOTIFICATION_SET, MODAL_NOTIFICATION_CLEAR} from "../store/config";

export const showModal = () => {
	return {
		type:MODAL_SHOW,
		show:true,
		timestamp:Date.now()
	}
};

export const hideModal = () => {
	return {
		type:MODAL_HIDE,
		show:false,
		data:{},
		active:false,
		timestamp:Date.now()
	}
};

export const newModalNotification = (data) => {
	return dispatch => {
		return dispatch(setModalNotification(data));
	}
};

export const setModalNotification = (data) => {
	return {
		type: MODAL_NOTIFICATION_SET,
		data: data,
		active: true,
		timestamp: Date.now()
	}
};

export const clearModalNotification = () => {
	return dispatch => {
		return dispatch(unsetModalNotification());
	}
};

export const unsetModalNotification = () => {
	return {
		type: MODAL_NOTIFICATION_CLEAR,
		data: {},
		active: false,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/modal.js